module.exports = __webpack_public_path__ + "static/img/zqyhd.d5c6192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zqyhd.png
// module id = TnsX
// module chunks = 29